<ng-container *transloco="let t">
  <app-page-template [showFooter]="false" [slateBackground]="true">

    <app-my-tracey-page-header [key]="'app.common.back'" (onBackCallback)="goBack()" [hideDefault]="true">
      <div slot="headerContent" (click)="goBack()" class="d-flex align-items-center justify-content-between justify-content-md-start w-100">
        <div class="slate-600 pe-3">
          {{ t('app.user.my.tracy.orders') }}
        </div>
      </div>
    </app-my-tracey-page-header>
    <div class="container pt-4">
      <div class="padding-bottom-92 pb-300-100">
        @if (registrations.length ?? 0 > 0) {
          <div infinite-scroll
               [infiniteScrollDistance]="1" class="row row-cols-1">
            @for (registration of registrations; track $index) {
              <div class="col mb-3">
                <app-order-grid-item
                  [registration]="registration"
                  [languages]="languages"
                  (onOpenOrderCallback)="goToOrder(registration)"/>
              </div>
            }
          </div>
        } @else {
          <app-empty-state/>
        }
      </div>
    </div>
  </app-page-template>
</ng-container>
